import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Link,
  TextField,
  Typography
} from '@mui/material';

import {
  textFieldSx
} from '../../../../../Common/components/Styles/InputStyles';

import { vitalFields } from './SoapEntryData';

import {
  sectionHeaderSx,
  sectionSx,
  sectionTitleSx,
  vitalFieldSx,
  vitalsGridSx,
  vsHxLinkSx
} from './SoapEntryStyles';

const VitalsSection = ({
  vitals,
  onChange,
  onOpenHistory
}) => {
  return (
    <Box sx={sectionSx}>
      <Box sx={sectionHeaderSx}>
        <Typography sx={sectionTitleSx}>
          Vital Signs:
        </Typography>

        <Link
          component="button"
          underline="always"
          onClick={onOpenHistory}
          sx={vsHxLinkSx}>
          VS Hx
        </Link>
      </Box>

      <Box sx={vitalsGridSx}>
        {vitalFields.map(field => (
          <TextField
            key={field.key}
            fullWidth
            label={field.label}
            size="small"
            value={vitals[field.key]}
            onChange={event =>
              onChange(field.key, event.target.value)
            }
            sx={{
              ...textFieldSx,
              ...vitalFieldSx
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

VitalsSection.propTypes = {
  vitals: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onOpenHistory: PropTypes.func.isRequired
};

export default VitalsSection;